"use client"
import { useState } from "react"
import { Content, isFilled, asText } from "@prismicio/client"
import { SliceComponentProps } from "@prismicio/react"
import Section from "@aura-design/system/section"
import Grid from "@aura-design/system/grid"
import Select from "@airplan/ui/select"
import Button from "@aura-design/system/button"
import { PrismicRichText } from "@airplan/ui/prismic-richtext"
import { useForm } from "@aura-design/system/form"
import useStorefrons from "@airplan/hooks/storefront"
import CollectionStorefront from "@airplan/ui/collection-storefront"
import Input from "@aura-design/system/input"
import { ReloadIcon } from "@radix-ui/react-icons"
import { createContainRegexFromString } from "@airplan/utils/data-view"

export default function Stores({ slice, storefront, uniqueCategories }) {
  const [dataFiltered, setDataFiltered] = useState(null)

  const formData = useForm({
    category: "",
    zones: "",
    name: "",
  })
  const { category, zones, name } = formData

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    let filter = storefront?.results

    if (category.value) {
      filter = filter.filter((item) => item.data.category === category.value)
    }

    if (zones.value) {
      for (const item of filter) {
        item.data.zones.includes(zones.value)
      }

      filter = filter.filter((item) =>
        item.data.zones.map((zone) => zone.zone).includes(zones.value),
      )
    }

    if (name.value) {
      const regex = createContainRegexFromString(
        name.value.toString().toLocaleLowerCase().trim(),
      )
      filter = filter.filter((item) => regex.test(asText(item.data.title)))
    }

    setDataFiltered(filter)
  }

  const handleOnReset = () => {
    category.reset()
    zones.reset()
    name.reset()
    setDataFiltered(null)
  }

  const screenData = dataFiltered ? dataFiltered : storefront?.results
  screenData?.sort((a, b) =>
    asText(a.data.title)?.localeCompare(asText(b.data.title) as string, "es", {
      sensitivity: "base",
    }),
  )

  return (
    <>
      <div className="shadow bg-white aura">
        <form onSubmit={handleOnSubmit}>
          <Grid col={["notZone"].includes(slice.variation) ? "three" : "four"}>
            <div>
              <label>Nombre</label>
              <Input {...name} />
            </div>
            {!["notZone"].includes(slice.variation) && (
              <div>
                <label>Zonas</label>
                <Select placeholder="Selecciona una opción" {...zones}>
                  {uniqueCategories.zones.sort().map((item) => {
                    return <option key={item}>{item}</option>
                  })}
                </Select>
              </div>
            )}
            <div>
              <label>Categorías</label>
              <Select placeholder="Selecciona una opción" {...category}>
                {uniqueCategories.categories.sort().map((item) => {
                  return <option key={item}>{item}</option>
                })}
              </Select>
            </div>
            <div>
              <Button label="Buscar" className="mt-1.5" isFluid />
            </div>
          </Grid>
        </form>
      </div>

      {(category?.value || name?.value || zones?.value) && (
        <div className="text-right">
          <Button mode="menu" onClick={handleOnReset}>
            <ReloadIcon className="icon mr-1" />
            Restablecer
          </Button>
        </div>
      )}

      <div className="text-center text-dark-blue mt-2">
        {isFilled.richText(slice.primary.title) && (
          <PrismicRichText field={slice.primary.title} />
        )}
        <hr className="line-yellow !m-auto" />
        <div className="mt-2">
          {storefront.isLoading ? (
            "Cargando..."
          ) : storefront.isError ? (
            "Ha occurido un error."
          ) : screenData.length === 0 ? (
            "Marca no disponible"
          ) : (
            <Grid col="four">
              {screenData.map((item) => (
                <CollectionStorefront doc={item} key={item.uid} />
              ))}
            </Grid>
          )}
        </div>
      </div>
    </>
  )
}
